import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { colspan: 5 }
const _hoisted_5 = { class: "d-flex justify-center align-center height-250px" }

import { ref, computed } from 'vue';
import { ALL_DEVICE_TYPE } from '@/services/consts';
import FirmwareRemoveDeviceType from '@/types/FirmwareRemoveDeviceType';
import ValidationErrors from '@/components/Common/ValidationErrors.vue';
import { REMOVE_DEVICE_TABLE_HEADEERS } from '@/services/consts/firmware_bulk_update';


export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveDeviceTable',
  props: {
    modelValue: {},
    isShowTable: { type: Boolean },
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const deviceList = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
})

const isAllCheck = ref(false)

function allCheckHandler() {
  deviceList.value?.forEach((device) => {
    device.isChecked = isAllCheck.value
  })
}
function rowCheckHandler(isCheck:boolean) {
  if (!isCheck) {
    isAllCheck.value = false
  }
  const allChecked = deviceList.value.every((device) => device.isChecked)
  isAllCheck.value = allChecked
}

function getModelTypeName(typeId: number | null) {
  if (!typeId) {
    return ''
  }
  const deviceType = ALL_DEVICE_TYPE.find((deviceType) => {
    return deviceType.id == typeId
  })
  return deviceType ? deviceType.type : ''
}

return (_ctx: any,_cache: any) => {
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createBlock(ValidationErrors, { messages: __props.errorMessages }, {
    default: _withCtx(() => [
      _createVNode(_component_v_table, {
        height: "300px",
        "fixed-height": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_1, [
                _createVNode(_component_v_checkbox, {
                  modelValue: isAllCheck.value,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((isAllCheck).value = $event)),
                    _cache[1] || (_cache[1] = ($event: any) => (allCheckHandler()))
                  ]
                }, null, 8, ["modelValue"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(REMOVE_DEVICE_TABLE_HEADEERS), (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: column,
                  class: "text-left"
                }, _toDisplayString(column), 1))
              }), 128))
            ])
          ]),
          (__props.isShowTable)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (device) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: device.device_id
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_checkbox, {
                        modelValue: device.isChecked,
                        "onUpdate:modelValue": [($event: any) => ((device.isChecked) = $event), ($event: any) => (rowCheckHandler(device.isChecked))]
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(device.operation_office?.operation_office_name), 1),
                    _createElementVNode("td", null, _toDisplayString(device.device_id), 1),
                    _createElementVNode("td", null, _toDisplayString(device.installation_vehicle?.number_plate), 1),
                    _createElementVNode("td", null, _toDisplayString(getModelTypeName(device.model_type)), 1)
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_progress_circular, {
                        color: "cyan-lighten-1",
                        indeterminate: ""
                      })
                    ])
                  ])
                ])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["messages"]))
}
}

})